// src/utils/recurringUtils.js

export const toYMD = (input) => {
    const d = new Date(input);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
};



export const addDaysYMD = (ymd, days) => {
    const [y, m, dd] = ymd.split("-").map(Number);
    const dt = new Date(y, m - 1, dd);
    dt.setDate(dt.getDate() + days);
    return toYMD(dt);
};

export const getDow = (d) => new Date(d).getDay(); // 0-6

const normalizeKey = (s) =>
    (s || "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "")
        .replace(/[^\w]/g, "");

export const buildSeriesKey = ({ title, dow, time }) =>
    `${normalizeKey(title)}_${dow}_${time || "00:00"}`;

// deterministic id untuk override occurrence (supaya upsert senang)
export const buildOverrideId = (seriesId, ymd) => `${seriesId}__${ymd}`;
